import React from 'react';
import styled from 'styled-components';
import {Typography} from '@material-ui/core';

const StyledSubHeader = styled(Typography)`
  color: ${props => props.theme.text};
  font-size: 16px;
  font-family: 'Trade Gothic Bold Condensed';
`;

interface ModalSubHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export default function ModalSubHeader({children, className}: ModalSubHeaderProps) {
  return <StyledSubHeader className={className}>{children}</StyledSubHeader>;
}
